import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export function CustomAttributeBase({ className, label, children }) {
  return (
    <CustomAttributeContainer className={className}>
      {_.trim(label) ? <CustomAttributeLabel className={`${className}-label`}>{label}</CustomAttributeLabel> : null}
      <CustomAttributeValue hasLabel={!!_.trim(label)} className={`${className}-value`}>
        {children}
      </CustomAttributeValue>
    </CustomAttributeContainer>
  );
}

export const CustomAttributeContainer = styled.div`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
`;

export const CustomAttributeLabel = styled.div`
  flex-basis: 50%;
  font-weight: ${p => p.theme.fontWeight.medium};
  margin-right: ${p => p.theme.spacing.small};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CustomAttributeValue = styled.div`
  flex-basis: ${p => (p.hasLabel ? '50%' : '100%')};
  min-width: 0;
`;

CustomAttributeBase.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  label: PropTypes.node,
};

export default CustomAttributeBase;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/summary/custom_attributes/custom_attribute_base.jsx